import * as React from "react";
import type { SVGProps } from "react";

/**
 * Slot Icon - 老虎机/转轴图标
 * Used for: Slots category
 */
const SlotIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={21}
    viewBox="0 0 48 48"
    {...props}
    fill={"currentColor"}
    fillRule={"evenodd"}
  >
    <path d="M4 19.829H.666v8.137h2.959a2.779 2.779 0 0 1 2.589-2.589c1.951-.233 2.607.73 3.7 1.11a9.767 9.767 0 0 0 1.48.37s-6.53 5.511-6.659 11.836h8.137s-.416-6.152 2.219-10.356c.336-.536 2.23-3.44 2.494-3.939-3.3-.1-6.982 0-6.982 0s-.761-2.431-1.2-3.49a7.5 7.5 0 0 0-2.083-.338 9.149 9.149 0 0 0-3.32.738v-1.479Zm31.711 5.988a4.094 4.094 0 0 1 1.178.016 12.186 12.186 0 0 1 2.4 1.057 9.48 9.48 0 0 0 1.431.358s-6.32 5.329-6.444 11.444h7.869s-.4-5.949 2.146-10.014c2.851-4.548 2.861-7.869 2.861-7.869h-3.219a4.543 4.543 0 0 1-2.862 1.073 10.167 10.167 0 0 1-2.721-.5 6.308 6.308 0 0 0-1.57-.211c-.28 1.501-.68 2.509-1.073 4.646ZM16.43 8.686h-5.295v12.945h4.707a4.422 4.422 0 0 1 4.119-4.119c3.1-.37 4.147 1.162 5.885 1.766a15.419 15.419 0 0 0 2.353.588S17.813 28.633 17.607 38.7h12.946s-.663-9.786 3.53-16.476c4.69-7.482 4.707-12.945 4.707-12.945h-5.3a7.473 7.473 0 0 1-4.707 1.765c-2.81 0-4.344-1.177-7.06-1.177a14.551 14.551 0 0 0-5.3 1.177V8.686Z" />
  </svg>
);

export default SlotIcon;

